import React from 'react';

export default {
    SimpChn : {
        formTitle: "「综合注册资讯系统」网上服务 - 查询表格", 
        steps_Particulars: "客户资料",

        PICSContent: ()=>      [<> 
            <p>1. <span style={{textDecoration:"underline"}}>收集目的</span></p>
            <p>
            土地注册处将会把本表格所收集的个人资料用于以下目的:-
                <ol style={{listStyleType: "lower-latin"}}>
                    <li>处理与提供土地注册处服务有关的事宜；</li>
                    <li>方便进行联络；以及</li>
                    <li>制备与土地注册处服务有关的统计资料。</li>
                </ol>
            </p>
            <p>
                你明白提供个人资料与否纯属自愿。倘若你不提供本表格所要求的资料，本处可能无法提供所要求的服务。
            </p>
            <p>
                <span style={{fontWeight:"bold"}}>请勿</span>提供任何没有明确规定必须提交的个人资料(包括关乎第三者的个人资料)。如本表格或所提交的任何与其有关的文件中包含任何第三者的资料，本处将视作你已获该第三者同意披露该等资料，以用于上述目的。
            </p>
            
            <p>2. <span style={{textDecoration:"underline"}}>个人资料的披露</span></p>
            <p>
                你明白为达到上文第一段中所述明目的而有需要时，你在本表格内所提供的个人资料可能会披露或转交予相关人士。
            </p>    
            <p>3. <span style={{textDecoration:"underline"}}>查阅个人资料</span></p>
            <p>
                你明白根据《个人资料(私隐)条例》(第486章) 第18和第22条，以及附表1第6原则，你有权要求查阅及更正本处所持有你的个人资料。根据该条例，本处有权就处理该等要求收取费用。任何该等要求可向本处的个人资料(私隐)主任提出(地址：香港金钟道66号金钟道政府合署28楼土地注册处)。
            </p>
        </>]
        ,
 
        // Form fields
        part_1_Particulars:         "I 客户资料", 
        part_2_OrderDetails:        "II 订单详情", 
        part_3_Issues:              "III 查询事项", 
        part_4_SignatoryDetails:    "IV 签署人资料",     
        
        // Form - Part1
        OlsAccName:     "登记用户账户名称/客户姓名", 
        OlsAccNo:       "登记用户账户号码", 
        ContactPerson:  "联络人姓名", 
        ContactPhone:   "联络电话号码", 
        ContactEmail:   "电邮地址",

        // Form - Part2
        TransOrder:         "交易参考类别", 
        field_transOrder_list:[
            {id: "TransOrder", value: "NaN_Trans_Opt_1", text: "付款交易编号"},
            {id: "TransOrder", value: "NaN_Trans_Opt_2", text: "订单编号" },
        ],
        TransactionNo:      "付款交易编号", 
        OrderNo:            "订单编号", 
        DateOfOrder:        "订单日期", 
        TimeOfOrder:        "订单时间", 
        OrderType:          "订单类别", 
        OrderType_Other:    "订单类别 - 其他",
        field_orderType_list:[
            {id: "OrderType", value: "NaN_OrderType_Opt_1", text: "土地登记册"},
            {id: "OrderType", value: "NaN_OrderType_Opt_2", text: "土地文件"},
            {id: "OrderType", value: "NaN_OrderType_Opt_3", text: "尚未记入土地登记册的注册摘要资料"},
            {id: "OrderType", value: "NaN_OrderType_Opt_4", text: "其他"},
        ],
        field_refType_list:[
            {id: "RefType", value: "NaN_RefType_Opt_1", text: "物业地址"},
            {id: "RefType", value: "NaN_RefType_Opt_2", text: "地段编号"},
            {id: "RefType", value: "NaN_RefType_Opt_3", text: "物业参考编号"},
            {id: "RefType", value: "NaN_RefType_Opt_4", text: "注册摘要编号"},
        ],

        // Form - Matter
        Problems1:          "如何查阅土地登记册", 

        Problems2:          "澄清土地登记册上的资料", 
        LandRegisterAttach: "登记册副本", 

        Problems3:          "影像问题", 
        ImageProblem:       "影像问题类别", 
        field_imageProblem_list:[
            {id: "ImageProblem", value: "NaN_Image_Opt_1", text: "不清晰"},
            {id: "ImageProblem", value: "NaN_Image_Opt_2", text: "不完整"},
            {id: "ImageProblem", value: "NaN_Image_Opt_3", text: "空白页"},            
        ],
        ImageAttach:        "有问题各页的副本", 

        Problems4:          "错误文件", 
        WrongDocAttach:     "首两页的副本", 

        Problems5:          "未能收取已订购的土地纪录并要求将土地纪录重发至", 
        RequestFor:         "电邮地址 / 传真号码", 

        Problems6:          "其他", 
        Others:             "详情", 

        // Form - Part3
        NameEN:             "签署者姓名", 
    }
}